import GoogleMapsLoader from 'google-maps';

import { googleMapsApiKey } from '../keys';
import mapStyle from './mapStyles';

class Map {
  constructor(mapContainer) {
    this.mapContainer = mapContainer;
    this.lat = this.mapContainer.getAttribute('data-lat');
    this.lng = this.mapContainer.getAttribute('data-lng');
    GoogleMapsLoader.KEY = googleMapsApiKey;
    GoogleMapsLoader.VERSION = '3.34';
  }

  init() {
    GoogleMapsLoader.load((google) => {
      const latLng = new google.maps.LatLng(this.lat, this.lng);
      const map = new google.maps.Map(this.mapContainer, {
        center: latLng,
        zoom: 10,
        styles: mapStyle
      });

      new google.maps.Marker({
        position: latLng,
        icon: '/public/images/icons/map-marker-on.png',
        map
      });
    });
  }
}

export default Map;
